/* eslint-disable @typescript-eslint/naming-convention */
import { get } from '@core/api/baseApi';

const getOrganizationInfo = (): Promise<any> => 
  get('/organizations/info');
  

export { getOrganizationInfo };
